import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useAuth } from "../lib/auth";

export const trialEnding = (a) => !!(a && a.billing_enabled && a.kind === "trial" && a.daysLeft <= 3);

export default function TrialBanner() {
  const { store } = useAuth();
  const a = store?.access;
  if (!trialEnding(a) || store.is_owner) return null;
  return (
    <section className="trial-alert" role="status" data-testid="trial-ending-banner">
      <span className="ta-icon" aria-hidden="true"><Clock size={20} /></span>
      <div className="ta-text">
        <b>Prøveperioden udløber om {a.daysLeft} {a.daysLeft === 1 ? "dag" : "dage"}</b>
        <span>{a.started ? "Tak – jeres abonnement er startet. Husk at betale fakturaen inden forfald." : "Start abonnement for at fortsætte."}</span>
      </div>
      <Link className="btn ta-btn" to="/billing" data-testid="trial-ending-link">
        {a.started ? "Se faktura" : "Start abonnement"}
      </Link>
    </section>
  );
}
